import type { Document, NodeId } from '@/core/document'

export interface HistorySnapshot {
  document: Document
  selectedNodeId: NodeId | null
}

export enum EditAction {
  GenericEdit = 'generic-edit',
  CropPhoto = 'crop-photo',
  CropAndRotatePhoto = 'crop-and-rotate-photo',
  MovePrint = 'move-print',
  AdjustPhoto = 'adjust-photo',
  RotatePhoto = 'rotate-photo',
  FlipPhoto = 'flip-photo',
  StraightenPhoto = 'straighten-photo',
  ResetOrientation = 'reset-orientation',
  AddFrame = 'add-frame',
  EditFrame = 'edit-frame',
  RemoveFrame = 'remove-frame',
  EnterCollage = 'enter-collage',
  LeaveCollage = 'leave-collage',
  ChangeCollageTemplate = 'change-collage-template',
  RestoreCollagePhoto = 'restore-collage-photo',
  AddCollagePhotos = 'add-collage-photos',
  ReplaceCollagePhoto = 'replace-collage-photo',
  RemoveCollagePhoto = 'remove-collage-photo',
  SwapCollagePhotos = 'swap-collage-photos',
  EditCollageStyle = 'edit-collage-style',
  ChangeOutputPreset = 'change-output-preset',
  ChangeOutputSplit = 'change-output-split',
}

export const EDIT_ACTION_LABELS: Readonly<Record<EditAction, string>> = {
  [EditAction.GenericEdit]: 'edit',
  [EditAction.CropPhoto]: 'crop photo',
  [EditAction.CropAndRotatePhoto]: 'crop and rotate photo',
  [EditAction.MovePrint]: 'move print',
  [EditAction.AdjustPhoto]: 'adjust photo',
  [EditAction.RotatePhoto]: 'rotate photo',
  [EditAction.FlipPhoto]: 'flip photo',
  [EditAction.StraightenPhoto]: 'straighten photo',
  [EditAction.ResetOrientation]: 'reset orientation',
  [EditAction.AddFrame]: 'add Polaroid frame',
  [EditAction.EditFrame]: 'edit frame',
  [EditAction.RemoveFrame]: 'remove frame',
  [EditAction.EnterCollage]: 'make collage',
  [EditAction.LeaveCollage]: 'leave collage',
  [EditAction.ChangeCollageTemplate]: 'change collage template',
  [EditAction.RestoreCollagePhoto]: 'restore collage photo',
  [EditAction.AddCollagePhotos]: 'add collage photos',
  [EditAction.ReplaceCollagePhoto]: 'replace collage photo',
  [EditAction.RemoveCollagePhoto]: 'remove collage photo',
  [EditAction.SwapCollagePhotos]: 'swap collage photos',
  [EditAction.EditCollageStyle]: 'edit collage style',
  [EditAction.ChangeOutputPreset]: 'change output preset',
  [EditAction.ChangeOutputSplit]: 'change output split',
}

export interface HistoryEntry {
  snapshot: HistorySnapshot
  action: EditAction
}

export interface HistoryState {
  readonly past: readonly HistoryEntry[]
  readonly future: readonly HistoryEntry[]
}

export const MAX_HISTORY_DEPTH = 100

export const EMPTY_HISTORY: HistoryState = Object.freeze({
  past: Object.freeze([]),
  future: Object.freeze([]),
})
